import axiosInstance from "./axiosInstance";

const getAllProducts = async ({ pageParam = 1 }) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const { data } = await axiosInstance.get(
      `/api/getAllProducts?page=${pageParam}&limit=8`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return {
      products: data.products,
      nextPage: pageParam + 1,
      totalPages: data.pagination.totalPages,
    };
  } catch (error) {
    throw new Error("Error fetching user points.");
  }
};

export default getAllProducts;
